import { useCallback } from "react";
import { useScheduleContext } from "../hooks/context/useScheduleContext";
import useApi from "../../../../utils/api";
import moment from "moment-timezone";
import { formatEvents } from "../helpers/data/formatEvents";

export const useDailyEventsApi = () => {
    const { authGet } = useApi();
    const { type, dispatch } = useScheduleContext();

    const fetchEvents = useCallback(async (date: string, params: Object) => {
        const url = type === "team"
            ? `/schedules/v2/date/${moment(date).format("YYYY-MM-DD")}/events`
            : `/my/schedules/v2/date/${moment(date).format("YYYY-MM-DD")}/events`;

        dispatch({ type: "set-more-modal-events" });
        try {
            const response = await authGet(url, { params });
            if (response) {
                dispatch({
                    type: "set-more-modal-events-success",
                    payload: {
                        moreModalEvents: formatEvents(response?.data || []),
                        totalItems: response.meta.total || 0
                    }
                });
            }
        } catch (err: any) {
            dispatch({ type: "set-more-modal-events-failed", payload: { error: err } });
        }
    }, [type, dispatch, authGet]);

    return { fetchEvents };
}